export { shortKey } from '@/components/_shared/format'

export function normMs(v) {
  const n = Number(v) || 0
  if (n <= 0) return 0
  return Math.round(n / 50) * 50
}

export function clampMs(v) {
  const n = Number(v) || 0
  const max = 60_000
  return Math.min(max, Math.max(0, normMs(n)))
}

export function msDisp(v) {
  const n = Number(v) || 0
  if (n <= 0) return '0ms'
  if (n < 1000) return `${n}ms`
  return `${(n / 1000).toFixed(2)}s`
}

export function formatMoney(v) {
  const n = Number(v || 0)
  if (!Number.isFinite(n) || n === 0) return '0'
  const sign = n > 0 ? '+' : ''
  const abs = Math.abs(n)

  let s
  if (abs >= 1_000_000_000) s = (abs / 1_000_000_000).toFixed(2) + 'B'
  else if (abs >= 1_000_000) s = (abs / 1_000_000).toFixed(2) + 'M'
  else if (abs >= 1_000) s = (abs / 1_000).toFixed(2) + 'K'
  else s = abs.toFixed(2)

  return sign + s
}

export function normAmount(v) {
  // разрешим "1_000_000" / "1 000 000" / "1000000"
  const s = String(v ?? '')
    .trim()
    .replaceAll('_', '')
    .replaceAll(' ', '')

  if (s === '') return '0'
  if (!/^\d+$/.test(s)) return '0'

  const n = s.replace(/^0+(\d)/, '$1')
  return n === '' ? '0' : n
}
